import type { ObjectSummary } from '../types/org.types';

// Salesforce system companions of a real object: sharing, history, feed,
// change event and tag tables. They never show on screen (the consultant
// Excel keeps them). Custom ones end in __Share, __History, __Feed,
// __ChangeEvent, __Tag; standard ones in Share, History, Feed, ChangeEvent,
// Tag (AccountShare, OpportunityFieldHistory, CaseFeed, ContactChangeEvent).
const SYSTEM_SUFFIX = /(Share|History|Feed|ChangeEvent|Tag)$/;

export function isSystemObject(apiName: string): boolean {
  if (apiName === 'Tag') return false;
  return SYSTEM_SUFFIX.test(apiName);
}

// "Objects that matter": every custom object, plus a standard object that
// holds records or carries automation. System objects never matter.
export function isObjectThatMatters(o: ObjectSummary, automationCount: number): boolean {
  if (isSystemObject(o.apiName)) return false;
  if (o.custom) return true;
  return (o.recordCount ?? 0) > 0 || automationCount > 0;
}

// A managed-package object carries a namespace prefix: ns__Name__c has two
// double underscores, a local custom object (Name__c) only one.
export function isManagedObject(apiName: string): boolean {
  return apiName.split('__').length > 2;
}
